'use strict';

import template from '../../templates/settings/Leave.ejs';
import FormView from 'commons/views/Form';
import loader from 'helpers/loader';
import modal from 'helpers/modal';
import LeaveType from 'newModels/leave-type';
import LeaveTypeModal from './LeaveTypeModal.js';
import Alerts from 'lib/alerts';

var leavePolicyPresets = [
    {
        leaveRenewalPolicy: 'calendarYear',
        leaveAccrual: false,
        leaveProrate: true
    },
    {
        leaveRenewalPolicy: 'joinDate',
        leaveAccrual: false,
        leaveProrate: false
    },
    {
        leaveRenewalPolicy: 'calendarYear',
        leaveAccrual: true,
        leaveProrate: true
    },
    {
        leaveRenewalPolicy: 'joinDate',
        leaveAccrual: true,
        leaveProrate: false
    }
];

module.exports = FormView.extend({
    events: function() {
        var parentEvents = _.isFunction(FormView.prototype.events) ?
            FormView.prototype.events() : FormView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'change .js-ext-days': 'updateDays',
            'change .js-ext-leave-type-name': 'updateLeaveTypeName',
            'click .js-add-leave-type': 'addLeaveType',
            'click .js-destroy-leave-type': 'destroyLeaveType'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            unsubmittedPayroll: null,
            leaveTypes: null
        });
        this.options.templateExtra = {leaveTypes: this.options.leaveTypes};
        this.modalEditView = new LeaveTypeModal({
            actOnSave:    true,
            actOnCancel:  false,
            actOnDestroy: false
        });
        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    render: function() {
        FormView.prototype.render.apply(this, arguments);
        setTimeout(this.initializeControls.bind(this), 1);
        this.toggleLeaveCarryForward();
        return false;
    },

    bindHandlers: function() {
        var r = FormView.prototype.bindHandlers.apply(this, arguments);

        this.model.on(
            'change:allowLeaveCarryForward',
            this.toggleLeaveCarryForward,
            this
        );
        this.model.on(
            'change:annualLeavePolicy',
            this.updateLeavePolicy,
            this
        );
        this.options.leaveTypes.on(
            'add sync reset remove',
            this.render,
            this
        );

        this.modalEditView.on(
            'saved', this.options.leaveTypes.add, this.options.leaveTypes
        );

        return r;
    },

    unbindHandlers: function() {
        var r = FormView.prototype.bindHandlers.apply(this, arguments);
        this.options.leaveTypes.off(null, null, this);
        this.modalEditView.off(null, null, this.options.leaveTypes);
        return r;
    },

    initializeControls: function() {
        // The UI design has a weird placement for the delete button
        this.$('.form-control-with-delete').each(function(i, control) {
            var $control = this.$(control);
            var $value = $control.find('.form-control-value');
            var $input = $control.find('.form-control');

            $value.css({
                display: 'inline-block',
                maxWidth: (
                    $input.width() -
                    $control.find('.btn-delete').outerWidth(true) - 5
                ) + 'px'
            }).text($input.val());

            $value.on('click', function() {
                $control.addClass('focus');
                $input.focus();
            });

            $input.on('keyup', function(ev) {
                var val = this.$(ev.target).val();
                $value.html(val);
            }.bind(this))
            .on('focus', function() {
                $control.addClass('focus');
            })
            .on('blur', function() {
                $control.removeClass('focus');
            });
        }.bind(this));
    },

    getRandomColor: function() {
        const random = (max = 256) => Math.floor((Math.random() * max) + 1);
        const pastel = (color) => Math.floor((color + 255) / 2);
        const hex = () => pastel(random()).toString(16);
        return `#${hex()}${hex()}${hex()}`;
    },

    addLeaveType: function(ev) {
        ev.preventDefault();
        this.modalEditView.setModel(new LeaveType({
            accruable: false,
            paid: true,
            annual: false,
            company: app.company,
            optional: true,
            color: this.getRandomColor(),
        })).show();
        return this;
    },

    destroyLeaveType: function(ev) {
        let typeId = this.$(ev.currentTarget).data('type-id');
        let model = this.options.leaveTypes.find(type => (type.id === typeId));

        if (!model) {
            return;
        }

        const text = 'Note: If this leave type has been utilized by an ' +
            'employee, it will remain under employment details.';

        Alerts.show('dangerConfirm', {
            text,
            confirmButtonText: 'Yes, Remove',
            callback: confirm => {
                if (!confirm) {
                    return;
                }
                return model.destroy().then(() => {
                    this.options.leaveTypes.remove(model);
                }, err => { Alerts.show('criticalError', err); });
            }
        });
    },

    updateLeavePolicy: function() {
        this.model.set(
            leavePolicyPresets[this.$('[name=annualLeavePolicy]').val()]
        );
    },

    updateDays: function($ev) {
        let typeId = this.$($ev.currentTarget).data('type-id');
        let days = this.getInputValue(this.$($ev.currentTarget));
        this.model.setLeaveDays({
            typeId: typeId,
            days: days
        });
    },

    updateLeaveTypeName: function(ev) {
        let typeId = this.$(ev.currentTarget).data('type-id');
        let name = this.getInputValue(this.$(ev.currentTarget));
        this.options.leaveTypes.find(type => (type.id === typeId)).set({
            name: name
        });
    },

    toggleLeaveCarryForward: function() {
        this.$('[name=daysCanCarryForward]').prop(
            'disabled',
            this.model.get('allowLeaveCarryForward') !== true
        );

        this.$('[name=carryForwardExpiryMonths]').prop(
            'disabled',
            this.model.get('allowLeaveCarryForward') !== true
        );
    },

    toggleUnpaidLeaveFixedDays: function() {
        this.$('[name=unpaidLeaveFixedDays]').prop(
            'disabled',
            this.model.get('recordUnpaidLeaveInPayroll') !== true ||
                this.model.get('unpaidLeaveCalculationType') !== 1
        );

        // because we reset unpaidLeaveFixedDays when switch to other type
        // we can use this value again whe switch back
        if (this.model.get('unpaidLeaveCalculationType') === 1) {
            var days = parseInt(this.$('[name=unpaidLeaveFixedDays]').val());
            this.model.set({'unpaidLeaveFixedDays': days});
        }
        this.toggleError('unpaidLeaveFixedDays');
    },

    resetPayrollConfirm: function() {
        if (!_.isObject(this.options.unsubmittedPayroll)) {
            return Promise.resolve(true);
        }

        return new Promise(function(resolve, reject) {
            modal.confirm({
                title: 'Your saved payroll will be modified!',
                text:  'You have an unsubmitted payroll saved. ' +
                    'If you continue, the payroll details of all employees ' +
                    'with unpaid leaves will be updated based on the ' +
                    'modifications you are about to save. Also, any unsaved ' +
                    'payroll details will be lost.',
                customClass:       'sweet-alert-error',
                confirmButtonText: 'Yes, save settings',
                callback: confirm => {
                    if (confirm) {
                        resolve(true);
                    } else {
                        reject();
                    }
                }
            });
        });
    },

    save: function(ev) {
        var $button = this.$(ev.currentTarget);
        var stopLoader;

        if (
            // TODO: Investigate - !this.model.wasValid() ||
            !this.model.isValid({forcePresenceValidation: true})
        ) {
            this.invalid(this.model, {errors: this.model.validationError});
            return;
        }

        return this.resetPayrollConfirm()
            .then(() => {
                stopLoader = loader.startFullScreen($button);
                return this.model.save().catch(err => {
                    if (this.model.wasValid()) {
                        // the error is not a validation error
                        throw err;
                    }
                    throw new Error('validationError');
                });
            })
            .then(() => {
                return this.options.leaveTypes.save();
            })
            .then(() => {
                return app.leaveTypes.fetch();
            })
            .then(() => {
                if (this.options.unsubmittedPayroll) {
                    return this.options.unsubmittedPayroll.resetUnpaidLeave();
                }

                return Promise.resolve(true);
            })
            .then(() => {
                modal.showAlertSuccess('Leave settings have been saved');
                return Promise.resolve(true);
            })
            .catch(err => {
                if (
                    typeof err === 'object' &&
                    err.message !== 'validationError'
                ) {
                    modal.error({text: err});
                }
            })
            .finally(() => {
                if (typeof stopLoader === 'function') {
                    stopLoader();
                }
            });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/Leave.js